import React from 'react';
import PropTypes from 'prop-types';
import { ContentPackageGridTemplate } from './shared/ContentPackageGridTemplate';

export const ContentPackageTemplate2a = ({
  data,
  content,
  isAboveTheFold = false
}) => {
  return (
    <ContentPackageGridTemplate
      gridConfig={{
        lead: false,
        medium: [0],
        small: [1, 'content_package_right'],
        bottom: null
      }}
      data={data}
      content={content}
      isAboveTheFold={isAboveTheFold}
    />
  );
};

ContentPackageTemplate2a.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  content: PropTypes.objectOf(PropTypes.any).isRequired,
  isAboveTheFold: PropTypes.bool
};
